var styleDataHash = "759a7eaa";
const injectCss = (() => {
  var css = `.z2Hs6{height:18px;position:relative;width:18px}.UmDOp,.iFRk7{height:100%;left:0;position:absolute;top:0;width:100%;fill:none;stroke-linecap:round}.iFRk7{animation:KYfTy 666ms linear infinite;opacity:.3}.UmDOp,.iFRk7{stroke:currentColor}.UmDOp{animation:KYfTy 2s linear infinite}@keyframes KYfTy{to{transform:rotate(1turn)}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var double_loader_default = {
  "wrapper": "z2Hs6",
  "top": "iFRk7",
  "bottom": "UmDOp",
  "rotation": "KYfTy"
};
export {
  double_loader_default as default,
  injectCss
};
//# sourceMappingURL=double-loader-scss.js.map
